import { ActionBarItem } from '@workwave-tidal/core/components/ActionBar'
import { Close } from '@workwave-tidal/core/icons'

import { ModalHeader } from '@/components/Modal'
import { useFormatDateInterval } from '@/hooks'

import { selectTerritoryLicensingLimits } from '@/features/domain/territory'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useController } from '../hooks/useController'
import { useTexts } from '../useTexts'

export function Header() {
  const { planningRange } = useSelector(selectTerritoryLicensingLimits)
  const {
    close,
    data: { model, exportEndDate, newPlanningRange, exportStartDate },
  } = useController()
  const texts = useTexts()
  const exportDateInterval = useFormatDateInterval(
    exportStartDate || new Date(),
    exportEndDate || new Date(),
    false,
    true,
  )

  const title = useMemo(() => {
    switch (model) {
      case 'export': {
        if (!exportStartDate || !exportEndDate) {
          throw new Error('Export start and end dates are required for export title')
        }

        const exportedDays = planningRange - newPlanningRange
        return texts.exportTitle(exportDateInterval, exportedDays)
      }

      case 'planningRange':
        return texts.planningRangeTitle

      case 'delete':
        return texts.deleteTitle

      default:
        return ''
    }
  }, [model, exportDateInterval, newPlanningRange, planningRange, texts])

  return (
    <ModalHeader
      actions={[<ActionBarItem icon={<Close />} key="close" onClick={close} label="" />]}
      title={title}
    />
  )
}
